import { Company } from 'ducks/companies/types';
import { Group } from 'ducks/groups/types';

export const toLineWithBreaks = (value: (Company | Group)[]) => {
    return value.reduce((acc: string, item: Company | Group, index: number) => {
        acc = index === 0 ? `${item.name}` : `${acc},\n${item.name}`;
        return acc;
    }, '');
};
